// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-483783f2] .el-form-item--mini .el-form-item__content {\n  text-align: right !important;\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
